export const AUTOMATION_WORKFLOWS = 'AUTOMATION_WORKFLOWS'

export const ALL_AUTOMATION_WORKFLOWS = 'ALL_AUTOMATION_WORKFLOWS'

export const AUTOMATION_WORKFLOWS_EXECUTION_LOGS =
   'AUTOMATION_WORKFLOWS_EXECUTION_LOGS'

export const PARAMETERS_STORE = 'PARAMETERS_STORE'
export const ANALYTICS_BUILDER = 'ANALYTICS_BUILDER'

export const ALL_REMINDERS = 'ALL_REMINDERS'
export const HOME_BOARD = 'HOME_BOARD'

export const DISTRIBUTION_RULES = 'DISTRIBUTION_RULES'

export const AGENT_ALLOCATION_GROUPS = 'AGENT_ALLOCATION_GROUPS'

export const EXECUTION_LOGS = 'EXECUTION_LOGS'
export const PINNED = 'PINNED'
export const CALLS = 'CALLS'

export const ADVANCED_ANALYTICS_DASHBOARDS = 'ADVANCED_ANALYTICS_DASHBOARDS'

export const DASHBOARDS = 'DASHBOARDS'

export const DOWNLOADS = 'DOWNLOADS'

export const ANALYTICS_COPILOT = 'ANALYTICS_COPILOT'

export const ACTIVITY_LOGS = 'ACTIVITY_LOGS'

export const ROLES = 'RULES'

export const USERS = 'USERS'

export const USER_GROUPS = 'USER_GROUPS'
